import { render, staticRenderFns } from "./BillingNavigation.vue?vue&type=template&id=10d02a4a&scoped=true&"
import script from "./BillingNavigation.vue?vue&type=script&lang=js&"
export * from "./BillingNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BillingNavigation.vue?vue&type=style&index=0&id=10d02a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d02a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d02a4a')) {
      api.createRecord('10d02a4a', component.options)
    } else {
      api.reload('10d02a4a', component.options)
    }
    module.hot.accept("./BillingNavigation.vue?vue&type=template&id=10d02a4a&scoped=true&", function () {
      api.rerender('10d02a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/BillingNavigation.vue"
export default component.exports